export const useTemplatesStore = defineStore('templates', {
  state: () => {
    return {};
  },

  actions: {
    async fetchByEvent({ workspaceDomain, eventId, type } = {}) {
      const response = await useApi.get('/templates', {
        params: { workspaceDomain, eventId, type },
      }).catch((error) => {
        console.error(error);
        useToast.error(useT('bcd321'));
      });

      return response?.results || [];
    },

    async duplicate({
      templateId,
      sourceWorkspaceDomain,
      targetWorkspaceDomain,
      targetEventId,
      emailResponseTemplateId,
    }) {
      const response = await useApi.post(`/templates/${templateId}/duplicate`, {
        body: {
          sourceWorkspaceDomain,
          targetWorkspaceDomain,
          targetEventId,
          emailResponseTemplateId: emailResponseTemplateId || null,
        },
      }).catch((error) => {
        console.error(error);
        useToast.error(useT('bcd322'));
      });

      return response;
    },
  },
});
